import Vue from 'vue'
import Router from 'vue-router'
import Layout from '@/layout/layout.vue'
import Check from '@/views/check/index.vue'
import Writing from '@/views/writing/index.vue'
import Login from '@/views/login/index.vue'
import Video from '@/views/video/index.vue'
import Word from '@/views/word/index.vue'
import ImageCheck from '@/views/checkimage/index.vue'
import VideoCheck from '@/views/checkvideo/index.vue'
import userCenter from '@/views/user/index.vue'
import Image from '@/views/image/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',  // 可选：'hash' 或 'history'
  routes: [
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', name: 'check', component: Check },
        { path: 'writing', name: 'writing', component: Writing },
        { path: 'video', name: 'video', component: Video },
        { path: 'word', name: 'word', component: Word },
        { path: 'imagecheck', name: 'images', component: ImageCheck},
        { path: 'videocheck', name: 'videocheck', component: VideoCheck},
        { path: 'usercenter', name: 'usercenter', component: userCenter},
        { path: 'image', name: 'image', component: Image}
      ]
    }
  ]
})
